import { StationaryBookingNextStepsFromStore } from '@components/BookingFlow/Stationary/StationaryBookingNextSteps';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { PageHeading } from '@components/Layouts/PageHeading';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useIsPaymentSuccessful } from '../../../../hooks/useIsPaymentSuccessful';
import { useCurrentBrand } from '../../../../stores/BrandStore/brandStore';
import { useStationaryBookingStore } from '../../../../stores/StationaryBookingStore';
import { getErrorTextBasedOnErrorType } from '../../../../utils/dinteroPayment';

export const StationaryBookingConfirmationWithPayment = () => {
  const { brandUrl } = useCurrentBrand();
  const clearStore = useStationaryBookingStore((state) => state.clearStore);

  const { error, isPaymentSuccessful } = useIsPaymentSuccessful();
  const confirmedTitle = t`Booking confirmed`;
  const failedTitle = t`Payment failed`;
  // eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show
  const confirmedMark = '🚀';

  return (
    <ContentWrapperCustomerApp hideBackButton>
      {isPaymentSuccessful ? (
        <div className='flex flex-col gap-4'>
          <PageHeading label={confirmedTitle} className='text-3xl font-bold text-primary md:text-4xl'>
            {confirmedTitle} {confirmedMark}
          </PageHeading>
          <NoddiCard contentClassName='flex items-center gap-4'>
            <NoddiIcon name='CircleCheck' size='medium' className='fill-green-500 text-white' />
            <h2 className='font-bold'>
              <Trans>We have received your payment</Trans>
            </h2>
          </NoddiCard>
          <StationaryBookingNextStepsFromStore />
          <NoddiLink to={brandUrl} className='w-full' onClick={clearStore}>
            <Trans>Close</Trans>
          </NoddiLink>
        </div>
      ) : (
        <NoddiBasicCard className='flex w-full flex-col items-center gap-4 text-center'>
          <PageHeading className='text-2xl font-bold'>{failedTitle}</PageHeading>
          <span>{getErrorTextBasedOnErrorType(error)}</span>

          <NoddiLink className='w-full' to={customerRoutes.newBookingSummary.getPath()}>
            <Trans>Try again</Trans>
          </NoddiLink>
        </NoddiBasicCard>
      )}
    </ContentWrapperCustomerApp>
  );
};
